import httpClient from './httpClient';


const getReservationBookingAsync = (bookingId) => httpClient.post('/api/v2/Reservation/GetBooking', { BookingPvid: bookingId });


const getReservationAsync = (filter) => httpClient.post('/api/v2/Reservation/GetReservation', filter);

const getConfig = (filter) => httpClient.post('/api/v2/Reservation/GetReservationConfig', filter);

var dateTimeReviver = function (key, value) {
  var a;
  if (typeof value === 'string') {
    a = /\/Date\((\d*)\)\//.exec(value);
    if (a) {
      return new Date(+a[1]);
    }
  }
  return value;
}

const ex = {
  getReservationBookingAsync,
  getReservationAsync,
  getConfig
}

export default ex;



// WEBPACK FOOTER //
// ./src/api/reservation-api.js